import { ISecurityProfileProps, GET_SECURITY_PROFILE } from '../../components/services/GraphQLSecurity';
import { IUserInfoProps } from '../../components/services/GraphQLShared';

export const actions = {
  RESET_SECURITY_PROFILE: 'RESET_SECURITY_PROFILE',
  SET_USER_INFO: 'SET_USER_INFO',
  GET_SECURITY_PROFILE_PENDING: 'GET_SECURITY_PROFILE_PENDING',
  GET_SECURITY_PROFILE_RESOLVED: 'GET_SECURITY_PROFILE_RESOLVED',
  GET_SECURITY_PROFILE_REJECTED: 'GET_SECURITY_PROFILE_REJECTED',
} as const;

export const resetSecurityProfile = () => ({ type: actions.RESET_SECURITY_PROFILE });

export const getSecurityProfile = (apolloClient: any) => async (dispatch: any) => {
  dispatch({ type: actions.GET_SECURITY_PROFILE_PENDING });
  try {
    // network-only: this thunk is also re-dispatched after a MAM sync clears the server-side
    // profile cache; Apollo's default cache-first would return the stale copy from app init.
    const { data } = await apolloClient.query({ query: GET_SECURITY_PROFILE.query, fetchPolicy: 'network-only' });
    const profile: ISecurityProfileProps = data[GET_SECURITY_PROFILE.rootNode][GET_SECURITY_PROFILE.queryNode];
    dispatch({ type: actions.GET_SECURITY_PROFILE_RESOLVED, profile });
  } catch (error) {
    dispatch({ type: actions.GET_SECURITY_PROFILE_REJECTED, error });
  }
};
export type SecurityActionTypes = SetUserInfoAction;

interface SetUserInfoAction {
  type: typeof actions.SET_USER_INFO;
  value: IUserInfoProps;
}
export function setUserInfo(value: IUserInfoProps): SecurityActionTypes {
  return { type: actions.SET_USER_INFO, value: value };
}
